export const units = [
  { label: "Toneladas", value: "toneladas", min: 1, max: 100 },
  { label: "Litros", value: "litros", min: 1, max: 100000 },
  {
    label: "Unidades",
    value: "unidades",
    min: 1,
    max: 100000,
  },
  { label: "Pallets", value: "pallets", min: 1, max: 100 },
  { label: "Otros", value: "otros" },
];
export const MAX_FILE_SIZE = 102400 * 100; //10MB * ..
